import { Select } from "PFComponents/select";
import { ClosureReasonKey, Option } from "PFCore/types";
import { useTranslation } from "react-i18next";

import css from "../close_confirm_modal.module.scss";

type CloseConfirmModalReasonSelectProps = {
  isVisible: boolean;
  closeOptions: Option<ClosureReasonKey>[];
  selectedReason: ClosureReasonKey | null;
  onSelectedReasonChange: (reason: ClosureReasonKey) => void;
};

export const CloseConfirmModalReasonSelect = ({
  isVisible,
  closeOptions,
  selectedReason,
  onSelectedReasonChange
}: CloseConfirmModalReasonSelectProps) => {
  const { t } = useTranslation("activities");

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <div className={css.actions}>
        <div className={css.reasons}>{t("closeActivity.reason")}</div>
      </div>
      <Select
        className={css.selectReason}
        options={closeOptions}
        value={selectedReason ?? undefined}
        onChange={(selected) => onSelectedReasonChange((selected as Option<ClosureReasonKey>).original)}
      />
    </>
  );
};
